const MEDIA_ITEMS = [
  {
    title: '《霸道总裁的甜蜜契约》PV公开',
    desc: '人气甜宠恋爱漫画动画化决定，首支预告片正式公开，敬请期待甜蜜上线。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20manga%20style%20illustration%20of%20a%20handsome%20CEO%20in%20a%20luxury%20office%20with%20warm%20golden%20lighting%2C%20soft%20romantic%20atmosphere%2C%20anime%20art%20style%2C%20clean%20composition%2C%20warm%20peach%20and%20cream%20tones&width=600&height=400&seq=media-01&orientation=landscape',
  },
  {
    title: '校草大人请多指教 动画化',
    desc: '校园纯爱天花板作品正式宣布动画化，原汁原味还原甜蜜心动瞬间。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20illustration%20of%20a%20handsome%20school%20boy%20under%20cherry%20blossoms%20in%20spring%2C%20warm%20sunlight%2C%20soft%20pastel%20colors%2C%20romantic%20school%20atmosphere%2C%20clean%20shoujo%20manga%20style&width=600&height=400&seq=media-02&orientation=landscape',
  },
  {
    title: '甜柚漫画 × 人气声优特别企划',
    desc: '多位人气声优为甜柚漫画热门作品配音，沉浸式体验甜蜜恋爱故事。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20anime%20style%20illustration%20of%20a%20recording%20studio%20with%20microphone%20and%20headphones%2C%20soft%20warm%20lighting%2C%20creative%20atmosphere%2C%20pastel%20pink%20and%20cream%20colors%2C%20clean%20composition&width=600&height=400&seq=media-03&orientation=landscape',
  },
  {
    title: '青梅竹马的恋爱日记 特别篇',
    desc: '治愈系人气作品特别篇上线，青梅竹马甜蜜告白名场面全收录。',
    img: 'https://readdy.ai/api/search-image?query=Heartwarming%20anime%20illustration%20of%20childhood%20friends%20sharing%20a%20sweet%20moment%20in%20a%20sunlit%20classroom%2C%20soft%20golden%20light%2C%20warm%20and%20pure%20atmosphere%2C%20shoujo%20manga%20art%20style%2C%20gentle%20colors&width=600&height=400&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="section-padding bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            精彩推荐
          </h2>
          <p className="text-foreground-600 mt-2 text-sm md:text-base">甜柚漫画精选内容与特别企划</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {MEDIA_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href="#media"
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute top-3 left-3 w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-white text-lg"></i>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="text-sm font-bold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-3 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}